import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const PasswordStrengthMeter = ({ password }) => {
  const requirements = [
    { regex: /.{8,}/, text: 'At least 8 characters' },
    { regex: /[0-9]/, text: 'At least 1 number' },
    { regex: /[a-z]/, text: 'At least 1 lowercase letter' },
    { regex: /[A-Z]/, text: 'At least 1 uppercase letter' },
    { regex: /[^A-Za-z0-9]/, text: 'At least 1 special character' },
  ];

  const getStrength = (pass) => {
    let multiplier = 0;
    requirements.forEach((req) => {
      if (req.regex.test(pass)) {
        multiplier += 1;
      }
    });
    return multiplier;
  };

  const strength = getStrength(password);

  const getStrengthColor = () => {
    if (strength === 0) return 'bg-gray-200 dark:bg-gray-700';
    if (strength <= 2) return 'bg-red-500';
    if (strength <= 4) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const getStrengthText = () => {
    if (strength === 0) return 'Very Weak';
    if (strength <= 2) return 'Weak';
    if (strength <= 4) return 'Fair';
    return 'Strong';
  };

  return (
    <div className="mt-2 space-y-2">
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs text-gray-500 dark:text-gray-400">Password strength</span>
        <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">
          {getStrengthText()}
        </span>
      </div>

      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 flex overflow-hidden">
        {[1, 2, 3, 4, 5].map((level) => (
          <div
            key={level}
            className={`h-full flex-1 border-r border-white/20 last:border-0 transition-colors duration-300 ${
              strength >= level ? getStrengthColor() : 'bg-transparent'
            }`}
          />
        ))}
      </div>

      <div className="pt-1">
        <p className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Password must contain:</p>
        <ul className="space-y-1">
          {requirements.map((req, index) => {
            const isMet = req.regex.test(password);
            return (
              <li key={index} className="flex items-center text-xs">
                {isMet ? (
                  <SafeIcon icon={FiCheck} className="text-green-500 mr-1 w-3 h-3 flex-shrink-0" />
                ) : (
                  <SafeIcon icon={FiX} className="text-gray-400 dark:text-gray-500 mr-1 w-3 h-3 flex-shrink-0" />
                )}
                <span className={isMet ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}>
                  {req.text}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;
